export default "__VITE_ASSET__tcKfwogJ__"